module.exports = __webpack_public_path__ + "img/mark_star_1_icon.02da1dc7.png";